import React from 'react';

import styled, { TC } from '@benzinga/themetron';

export const none = 'unlisted';

export const PreferencesSubsection: React.FC<
  React.PropsWithChildren<{ hideIfFalsely?: boolean; title: string }>
> = props => {
  if (props.hideIfFalsely && !props.children) {
    return null;
  }
  return (
    <Subsection>
      <SubsectionTitle>{props.title}</SubsectionTitle>
      <div>{props.children || none}</div>
    </Subsection>
  );
};

const Subsection = styled(TC.Column)`
  margin-bottom: 0.5em;
`;

const SubsectionTitle = styled(TC.Row)`
  color: ${({ theme }) => theme.colors.foregroundInactive};
  font-size: 0.8125em;
  margin: 1em 0 0.5em;
  text-transform: uppercase;
`;
